import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {ITransfer} from '@api/models/transfer/transfer';
import {UrlService} from '@utils/services/url/url.service';
import {IMAGE_RESOLUTION} from '@api/models/image/image-resolution';
import {IPicture} from '@api/models/image/picture';
import {ImageSubType} from '@api/models/image/image-type';
import {ITransferTeam} from '@api/models/transfer/transfer-team';
import {TransfersHttpService} from '@api/http/transfers/transfers-http.service';
import {getUiString} from '@api/models/transfer/transfer-period';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {EntityType} from '@lib/models/entity/entity-type';

@Component({
    selector: 'lib-transfers-table',
    templateUrl: './transfers-table.component.html',
    styleUrls: ['./transfers-table.component.scss']
})
export class TransfersTableComponent implements OnInit {

    @Output() public sendPageView = new EventEmitter();
    @Input() public entityType: EntityType;
    @Input() public entityId: string;
    @Input() public pageSize: number;
    @Input() public colorScheme = ColorScheme.Dark;
    public transfers: ITransfer[] = [];
    public imageRes = IMAGE_RESOLUTION.MEDIUM;
    public loading = true;
    public moreTransfersAvailable = true;
    public getLink = UrlService.getSubdomainUrl;

    constructor(public transfersHttpService: TransfersHttpService) { }

    public async ngOnInit(): Promise<void> {
        await this.loadMoreTransfers()
        this.loading = false;
    }

    async loadMoreTransfers() {
        this.sendPageView.emit();
        const response = await this.transfersHttpService.getTransfers(this.entityType, this.entityId, this.transfers.length, this.pageSize);
        this.transfers = this.transfers.concat(response.data);
        this.moreTransfersAvailable = this.transfers.length < response.total_count;
    }

    public getLogoPicture(team: ITransferTeam): IPicture {
        return team.pictures.find(picture => picture.subtype === ImageSubType.LOGO)
    }

    public getSeasonInfo(transfer: ITransfer): string | null {
      const period = getUiString(transfer.season_info.period);
      let seasonInfo: string;
      if (transfer.season_info.year) {
        seasonInfo = transfer.season_info.year;
      } else if (transfer.season_info.ui_name) {
        seasonInfo = transfer.season_info.ui_name
      } else {
        return null
      }
      if (period) {
        seasonInfo = period + ' ' + seasonInfo;
      }
      return seasonInfo;
    }

    public getTeamName(team: ITransferTeam): string | null {
      if (!team.name) {
        return null;
      }
      if (team.abroad && team.association) {
        return team.name + ' ' + '(' + team.association + ')';
      }
      return team.name;
    }
}
